// import { get, getAll } from '@bigyouth/base'
import scrollManager from '../utils/scrollManager'
import withScroll from '../hoc/withScroll'
import onResize from '../utils/onResize'

export default withScroll({
  name: 'header',

  previousScroll: 0,
  isOpen: false,

  ui: {
    burger: '[js-header-burger]',
    panel: '[js-header-panel]',
  },

  events: [
    {
      on: 'click',
      target: 'burger',
      handle () {
        if (this.ui.panel.classList.contains('is-visible')) {
          scrollManager.restart()
        } else {
          scrollManager.stop()
        }

        this.ui.panel.classList.toggle('is-visible')
        this.ui.burger.classList.toggle('is-active')
        this.el.classList.toggle('is-open')

        const scrollBarWidth = window.innerWidth - document.querySelector('.main-nav__inner').clientWidth
        document.body.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`)
      },
    },
  ],

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))
    this.headerHeight = this.el.offsetHeight
  },

  componentWillUnmount () {
    this.off()
  },

  onResize () {
    this.headerHeight = this.el.offsetHeight
  },

  onScroll ({ y }) {
    if (y > this.headerHeight) {
      if (!this.el.classList.contains('is-fixed')) {
        this.el.classList.add('is-fixed')

        setTimeout(() => {
          this.el.classList.add('has-transition')
        }, 200)
      }

      if (Math.abs(y - this.previousScroll) >= 10) {
        if (y < this.previousScroll) {
          this.el.classList.add('is-visible')
        } else {
          this.el.classList.remove('is-visible')
        }
      }
    } else {
      this.el.classList.remove('is-visible', 'is-fixed', 'has-transition')
    }

    this.previousScroll = y
  },
})
